/* unplugin-vue-components disabled */import { render } from "./sh-contacts.vue?vue&type=template&id=05c23d33&scoped=true"
import script from "./sh-contacts.vue?vue&type=script&lang=js"
export * from "./sh-contacts.vue?vue&type=script&lang=js"

import "./sh-contacts.vue?vue&type=style&index=0&id=05c23d33&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05c23d33"],['__file',"src/pages/sh-contacts/sh-contacts.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "05c23d33"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('05c23d33', __exports__)) {
    api.reload('05c23d33', __exports__)
  }
  
  module.hot.accept("./sh-contacts.vue?vue&type=template&id=05c23d33&scoped=true", () => {
    api.rerender('05c23d33', render)
  })

}


export default __exports__